
'use strict'

if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
  module.exports = require('./index.cjs.development.cjs')
} else {
  module.exports = require('./index.cjs.production.min.cjs')
}
